import { useContext } from 'react';
import { MstContext } from '~/contexts/mst_context';

const useMst = () => useContext(MstContext);

export default useMst;
